import { Action } from 'redux';

import { SiteNamesRequest, SitesNamesRequestSucceeded } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { ISiteNameSansId } from '../../ts/ServerApi/types/ISiteNameSansId';

// SiteNamesRequestAction

export interface SiteNamesRequestAction extends Action {}

export function siteNamesRequest(): SiteNamesRequestAction {
  return {
    type: SiteNamesRequest
  };
}

export const isSiteNamesRequestAction = isActionFactory<SiteNamesRequestAction>(SiteNamesRequest);

// SitesNamesRequestSucceededAction

export interface SitesNamesRequestSucceededAction extends Action {
  readonly sites: ReadonlyArray<ISiteNameSansId>;
}

export function siteNamesRequestSucceeded(sites: ReadonlyArray<ISiteNameSansId>): SitesNamesRequestSucceededAction {
  return {
    type: SitesNamesRequestSucceeded,
    sites: sites
  };
}

export const isSiteNamesRequestSucceededAction = isActionFactory<SitesNamesRequestSucceededAction>(SitesNamesRequestSucceeded);
